<template>
  <div class="header-wrapper row m-0">
    <!-- Add a wrapper specifically for Greeting -->
    <div class="greeting-container">
      <Greeting />
    </div>

    <div class="nav-left col-xxl-7 col-xl-6 col-md-7 col-8 pull-left right-header p-0 ms-auto">
      <ul class="nav-menus">
        <!-- Removed Greeting from here -->
      </ul>
    </div>

    <div class="nav-right col-xxl-7 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto">
      <ul class="nav-menus">
        <Profile />
      </ul>
    </div>
  </div>
</template>


<script>
import Greeting from './greeting.vue';  // Import the Greeting component
import { Autoplay } from "swiper";
import "swiper/css";
import Profile from './profile';

export default {
  components: {
    Profile, Greeting, // Add Greeting component here
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
};
</script>

<style scoped>
.header-wrapper {
  position: relative; /* Ensure the header-wrapper is the relative container */
}

.greeting-container {
  position: absolute;
  top: 10px; /* Align at the top of the header */
  left: 10px; /* Align at the left edge of the header */
  padding: 10px; /* Add some padding if needed */
}

@media (max-width: 768px) {
  .greeting-container {
    /* Adjust for smaller screens if needed */
    padding: 5px;
  }
}
</style>
